import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
	list: [],
	documentHistory: null,
	total: 0,
	document: null,
	error: "",
	loading: false,
	loadingCount: 0,
	folderLoading: false,
	folderLoadingCount: 0,
	folderData: [],
	folders: [],
	files: [],
	selectedFolder: null,
	currentFolderId: null,
	folderContent: { folders: [], files: [] }
};

// ADD_document
export const addDocument = createAsyncThunk(
	"document/addDocument",
	async (values, { rejectWithValue }) => {
		try {
			console.log("slice values", values);
			const { data } = await axios({
				method: "post",
				headers: {
					Accept: "application/json",
					"Content-Type": "multipart/form-data",
				},
				url: `document-form/uploadDocument`,
				data: {
					...values,
				},
			});
			console.log("data", data);
			toast.success("Document created successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			console.log("Error response:", error.response);

			// Handle server-side validation errors
			if (error.response && error.response.data && error.response.data.message) {
				toast.error(error.response.data.message); // Display the server-side error message
			} else {
				toast.error("Error in creating document, try again!");
			}

			return rejectWithValue({
				message: error.response?.data?.message || "Unknown error occurred",
			});
		}
	}
);


export const assignFolderPermission = createAsyncThunk(
	"document/assignFolderPermission",
	async (values, { rejectWithValue }) => {
		try {
			console.log("slice values", values);
			const { data } = await axios({
				method: "post",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json",
				},
				url: `document-form/assignFolderPermission`,
				data: {
					...values,
				},
			});
			console.log("data", data);
			toast.success("Assign Permission successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			console.log("Error response:", error.response);

			// Handle server-side validation errors
			if (error.response && error.response.data && error.response.data.message) {
				toast.error(error.response.data.message); // Display the server-side error message
			} else {
				toast.error("Error in creating document, try again!");
			}

			return rejectWithValue({
				message: error.response?.data?.message || "Unknown error occurred",
			});
		}
	}
);
export const createFolder = createAsyncThunk(

	"document/createFolder",
	async (values, { rejectWithValue }) => {
		try {
			console.log("slice values", values);
			const { data } = await axios({
				method: "post",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json", // Corrected to application/json if you're not uploading files
				},
				url: `document-form/createFolder`,
				data: {
					...values,
				},
			});
			console.log("data", data);
			toast.success("Folder created successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			console.log("Error response:", error.response);

			// Handle server-side validation errors
			if (error.response && error.response.data && error.response.data.message) {
				toast.error(error.response.data.message);
			} else {
				toast.error("Error in creating document, try again!");
			}

			return rejectWithValue({
				message: error.response?.data?.message || "Unknown error occurred",
			});
		}
	}
);


// Approve_document
export const updatedocumentForm = createAsyncThunk(
	"document/updatedocumentForm",
	async ({ id, values }) => {
		try {
			const { data } = await axios({
				method: "post",
				headers: {
					Accept: "application/json",
					"Content-Type": "multipart/form-data",
				},
				url: `document-form/updateDocument`,
				data: values,
			});

			toast.success(" Profile image update successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in approving try again");
			console.log(error.message);
		}
	}
);

// document_DETAILS
export const getDocumentsByUserId = createAsyncThunk(
	"document/getDocumentsByUserId",
	async (id) => {
		try {
			const data = await axios.get(`document-form/getDocumentsByUserId/${id}`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

// get document by status and pagination
export const loaddocumentFormByStatus = createAsyncThunk(
	"document/loaddocumentFormByStatus",
	async ({ status, page, limit }) => {
		try {
			const { data } = await axios.get(
				`document-form?page=${page}&count=${limit}&status=${status}`
			);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

// documents
export const loadAlldocumentForm = createAsyncThunk(
	"document/loadAlldocumentForm",
	async () => {
		try {
			const { data } = await axios.get(`document-form?query=all`);

			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

// count document forms
export const countdocumentForm = createAsyncThunk(
	"document/countdocumentForm",
	async () => {
		try {
			const { data } = await axios.get(`document-form`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

// get Single document history
export const loadSingledocumentHistory = createAsyncThunk(
	"document/loadSingledocumentHistory",
	async (id) => {
		// console.log("gettinIDfromComponent", id);
		try {
			const { data } = await axios.get(`document-form/document-history/${id}/`);
			// console.log("dataFromAPI: ", data);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

export const fetchFolderContents = createAsyncThunk('folder/fetchFolderContents', async (folderName, { rejectWithValue }) => {
	try {
		const response = await axios.get(`/document-form/listFolderContents/${folderName}`);
		return response.data.files; // List of files and folders in the selected folder
	} catch (error) {
		return rejectWithValue(error.response.data); // Error handling
	}
});

export const fetchFolderList = createAsyncThunk(
	"folder/fetchFolderList",
	async (userId, { rejectWithValue }) => {
		try {
			const response = await axios.get(`/document-form/FolderList/${userId}`);
			return response.data;
		} catch (error) {
			return rejectWithValue(error.response?.data || "Failed to fetch folders");
		}
	}
);


export const getFolderFiles = createAsyncThunk(
	"folder/getFolderFiles",
	async (folderId, { rejectWithValue }) => {
		try {
			const response = await axios.get(`/document-form/folders/${folderId}/contents`);
			return response.data;
		} catch (error) {
			return rejectWithValue(error.response?.data || "Failed to fetch folders");
		}
	}
);

// Thunk to upload a file to a folder
export const uploadFile = createAsyncThunk('folder/uploadFile', async ({ file, folderId, uploadedBy }, { rejectWithValue }) => {
	const formData = new FormData();

	// Log the file object to check its content
	console.log("File details before appending:", file);

	// Append file, folderId, and uploadedBy to FormData
	formData.append('file', file);
	formData.append('folderId', folderId);    // Add folderId
	formData.append('uploadedBy', uploadedBy); // Add uploadedBy

	// Log FormData contents using forEach to inspect each key-value pair
	formData.forEach((value, key) => {
		console.log(key, value); // Should log 'file', 'folderId', 'uploadedBy', and the actual file object
	});

	try {
		const response = await axios.post(`/document-form/uploadFile`, formData, {
			headers: { 'Content-Type': 'multipart/form-data' },
		});
		console.log("Server Response:", response.data);
		return response.data;
	} catch (error) {
		console.error("Upload Error:", error);
		return rejectWithValue(error.response?.data || error.message);
	}
});




export const deleteFolder = createAsyncThunk(
	"document/deleteFolder",
	async ({ folderId, folderName }, { rejectWithValue }) => {
		try {
			console.log("Delete folderName", folderName);
			const { data } = await axios({
				method: "delete",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json",
				},
				url: `document-form/deleteFolder/${folderName}`,
				data: { folderId }
			});
			console.log("Delete response data", data);
			toast.success("Folder deleted successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			console.log("Delete error response:", error.response);

			if (error.response && error.response.data && error.response.data.message) {
				toast.error(error.response.data.message);
			} else {
				toast.error("Error in deleting folder, try again!");
			}

			return rejectWithValue({
				message: error.response?.data?.message || "Unknown error occurred",
			});
		}
	}
);

// moveFolder thunk
export const moveFolder = createAsyncThunk(
  "document/moveFolder",
  async ({ folderId, newParentId, folderName }, { rejectWithValue }) => {
    try {
      const response = await axios.post("/document-form/move-folder", {
        folderId,
        newParentId,
        folderName,
      });

      toast.success(`Folder "${folderName}" moved successfully`);
      return response.data;
    } catch (error) {
      toast.error("Failed to move folder");
      return rejectWithValue(
        error.response?.data?.message || "Failed to move folder"
      );
    }
  }
);

// moveFile thunk
export const moveFile = createAsyncThunk(
  "document/moveFile",
  async ({ fileId, newFolderId }, { rejectWithValue }) => {
    try {
      const response = await axios.post("/document-form/move-file", {
        fileId,
        newFolderId,
      });

      toast.success("File moved successfully");
      return response.data;
    } catch (error) {
      toast.error("Failed to move file");
      return rejectWithValue(
        error.response?.data?.message || "Failed to move file"
      );
    }
  }
);

// copyFolder thunk
export const copyFolder = createAsyncThunk(
  "document/copyFolder",
  async ({ folderId, targetFolderId, folderName }, { rejectWithValue }) => {
    try {
      const response = await axios.post("/document-form/copy-folder", {
        folderId,
        targetFolderId,
        folderName,
      });

      toast.success(`Folder "${folderName}" copied successfully`);
      return response.data;
    } catch (error) {
      toast.error("Failed to copy folder");
      return rejectWithValue(
        error.response?.data?.message || "Failed to copy folder"
      );
    }
  }
);

// copyFile thunk
export const copyFile = createAsyncThunk(
  "document/copyFile",
  async ({ fileId, targetFolderId }, { rejectWithValue }) => {
    try {
      const response = await axios.post("/document-form/copy-file", {
        fileId,
        targetFolderId,
      });

      toast.success("File copied successfully");
      return response.data;
    } catch (error) {
      toast.error("Failed to copy file");
      return rejectWithValue(
        error.response?.data?.message || "Failed to copy file"
      );
    }
  }
);


export const deleteFile = createAsyncThunk(
	"document/deleteFile",
	async ({ fileId }, { rejectWithValue }) => {
		try {
			const { data } = await axios({
				method: "delete",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json",
				},
				url: `document-form/deleteFile/${fileId}`,
				data: { fileId }
			});
			console.log("Delete response data", data);
			toast.success("File deleted successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			console.log("Delete error response:", error.response);

			if (error.response && error.response.data && error.response.data.message) {
				toast.error(error.response.data.message);
			} else {
				toast.error("Error in deleting file, try again!");
			}

			return rejectWithValue({
				message: error.response?.data?.message || "Unknown error occurred",
			});
		}
	}
);

export const renameFolder = createAsyncThunk(
	"document/renameFolder",
	async ({ oldName, folderId, newFolderName, parentId }, { rejectWithValue }) => {
		try {
			const response = await axios.put(
				`/document-form/renameFolder/${oldName}`,
				{ folderId, newFolderName, parentId }
			);
			return response.data;
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	}
);

export const renameFile = createAsyncThunk(
	"document/renameFile",
	async ({ currentFileName, newFileName, folderId }, { rejectWithValue }) => {
	  try {
		const response = await axios.put(
		  `/document-form/renameFile/${currentFileName}`,
		  { newFileName, folderId }
		);
		return response.data;
	  } catch (err) {
		return rejectWithValue(err.response.data);
	  }
	}
  );

export const checkFolderPermission = createAsyncThunk(
	"document/checkFolderPermission",
	async (folderId, userId) => {
		console.log("call", folderId, userId);
		
		try {
			const { data } = await axios.post(`document-form/checkFolderPermission`,
				{folderId: folderId, userId: userId}
			);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);


const documentFormSlice = createSlice({
	name: "documentForm",
	initialState,
	reducers: {
		clearDocumentForm: (state) => {
			state.document = null;
		},
		setSelectedFolder: (state, action) => {
			state.selectedFolder = action.payload;
		},
		setSliceCurrentFolderId: (state, action) => {
			state.currentFolderId = action.payload;
		}
	},
	extraReducers: (builder) => {
		const beginLoading = (state) => {
			state.loadingCount = (state.loadingCount || 0) + 1;
			state.loading = state.loadingCount > 0;
		};

		const endLoading = (state) => {
			state.loadingCount = Math.max(0, (state.loadingCount || 0) - 1);
			state.loading = state.loadingCount > 0;
		};

		const beginFolderLoading = (state) => {
			state.folderLoadingCount = (state.folderLoadingCount || 0) + 1;
			state.folderLoading = state.folderLoadingCount > 0;
		};

		const endFolderLoading = (state) => {
			state.folderLoadingCount = Math.max(0, (state.folderLoadingCount || 0) - 1);
			state.folderLoading = state.folderLoadingCount > 0;
		};

		// 1) ====== builders for loadAlldocumentForm ======

		builder.addCase(loadAlldocumentForm.pending, (state) => {
			beginLoading(state);
		});

		builder.addCase(loadAlldocumentForm.fulfilled, (state, action) => {
			endLoading(state);
			state.documentHistory = action.payload;
		});

		builder.addCase(loadAlldocumentForm.rejected, (state, action) => {
			endLoading(state);
			state.error = action.payload.message;
		});
		builder.addCase(renameFolder.pending, (state) => {
			beginLoading(state);
			beginFolderLoading(state);
		});
		builder.addCase(renameFolder.fulfilled, (state, action) => {
			endLoading(state);
			endFolderLoading(state);
			// Update the folderData state with the new folder name
			const { newFolderPath } = action.payload;
			state.folderData = state.folderData.map((folder) =>
				folder === action.meta.arg.currentFolderName ? newFolderPath : folder
			);
		});
		builder.addCase(renameFolder.rejected, (state, action) => {
			endLoading(state);
			endFolderLoading(state);
			state.error = action.payload;
		});

		builder.addCase(renameFile.pending, (state) => {
			beginLoading(state);
		});
		builder.addCase(renameFile.fulfilled, (state, action) => {
			endLoading(state);
			// Update the folderData state with the new folder name
			const { newFolderPath } = action.payload;
			state.folderData = state.folderData.map((folder) =>
				folder === action.meta.arg.currentFolderName ? newFolderPath : folder
			);
		});
		builder.addCase(renameFile.rejected, (state, action) => {
			endLoading(state);
			state.error = action.payload;
		});


		// 


		builder.addCase(addDocument.pending, (state) => {
			beginLoading(state);
		});

		builder.addCase(addDocument.fulfilled, (state, action) => {
			endLoading(state);
		});

		builder.addCase(addDocument.rejected, (state, action) => {
			endLoading(state);
			state.error = action.payload.message;
		});

		builder.addCase(moveFolder.pending, (state) => {
			beginLoading(state);
			beginFolderLoading(state);
		});

		builder.addCase(moveFolder.fulfilled, (state, action) => {
			endLoading(state);
			endFolderLoading(state);
		});

		builder.addCase(moveFolder.rejected, (state, action) => {
			endLoading(state);
			endFolderLoading(state);
			state.error = action.payload.message;
		});

		builder.addCase(moveFile.pending, (state) => {
			beginLoading(state);
			beginFolderLoading(state);
		});

		builder.addCase(moveFile.fulfilled, (state, action) => {
			endLoading(state);
			endFolderLoading(state);
		});

		builder.addCase(moveFile.rejected, (state, action) => {
			endLoading(state);
			endFolderLoading(state);
			state.error = action.payload.message;
		});
		
		builder.addCase(assignFolderPermission.pending, (state) => {
			beginLoading(state);
		});

		builder.addCase(assignFolderPermission.fulfilled, (state, action) => {
			endLoading(state);
		});

		builder.addCase(assignFolderPermission.rejected, (state, action) => {
			endLoading(state);
			state.error = action.payload.message;
		});

		builder.addCase(createFolder.pending, (state) => {
			beginLoading(state);
			beginFolderLoading(state);
		});

		builder.addCase(createFolder.fulfilled, (state, action) => {
			endLoading(state);
			endFolderLoading(state);
		});

		builder.addCase(createFolder.rejected, (state, action) => {
			endLoading(state);
			endFolderLoading(state);
			state.error = action.payload.message;
		});


		// 3) ====== builders for getDocumentsByUserId ======

		builder.addCase(getDocumentsByUserId.pending, (state) => {
			beginLoading(state);
		});

		builder.addCase(getDocumentsByUserId.fulfilled, (state, action) => {
			endLoading(state);
			state.document = action.payload;
		});

		builder.addCase(getDocumentsByUserId.rejected, (state, action) => {
			endLoading(state);
			state.error = action.payload.message;
		});

		// 4) ====== builders for loaddocumentFormByStatus ======

		builder.addCase(loaddocumentFormByStatus.pending, (state) => {
			beginLoading(state);
		});

		builder.addCase(loaddocumentFormByStatus.fulfilled, (state, action) => {
			endLoading(state);
			state.list = action.payload;
		});

		builder.addCase(loaddocumentFormByStatus.rejected, (state, action) => {
			endLoading(state);
			state.error = action.payload.message;
		});

		// 3) ====== builders for updatedocumentForm ======

		builder.addCase(updatedocumentForm.pending, (state) => {
			beginLoading(state);
		});

		builder.addCase(updatedocumentForm.fulfilled, (state, action) => {
			endLoading(state);
			const list = [...state.list];
			const index = list.findIndex(
				(document) => document.id === parseInt(action.payload.data.id)
			);
			list[index] = action.payload.data;
			state.list = list;
		});

		builder.addCase(updatedocumentForm.rejected, (state, action) => {
			endLoading(state);
			state.error = action.payload.message;
		});



		// 5) ====== builders for countdocumentForm ======

		builder.addCase(countdocumentForm.pending, (state) => {
			beginLoading(state);
		});

		builder.addCase(countdocumentForm.fulfilled, (state, action) => {
			endLoading(state);
			const length = action.payload.length;
			state.total = length;
		});

		builder.addCase(countdocumentForm.rejected, (state, action) => {
			endLoading(state);
			state.error = action.payload.message;
		});

		// 6) ====== builders for loadSingledocumentHistory ======

		builder.addCase(loadSingledocumentHistory.pending, (state) => {
			beginLoading(state);
		});

		builder.addCase(loadSingledocumentHistory.fulfilled, (state, action) => {
			console.log(action.payload);
			endLoading(state);
			state.documentHistory = action.payload;
		});

		builder.addCase(loadSingledocumentHistory.rejected, (state, action) => {
			endLoading(state);
			state.error = action.payload.message;
		});

		builder.addCase(fetchFolderContents.pending, (state) => {
			beginLoading(state);
		})
		builder.addCase(fetchFolderContents.fulfilled, (state, action) => {
			endLoading(state);
			state.folderData = action.payload;
		})
		builder.addCase(fetchFolderContents.rejected, (state, action) => {
			endLoading(state);
			state.error = action.payload;
		})

		builder.addCase(fetchFolderList.pending, (state) => {
			beginLoading(state);
			beginFolderLoading(state);
		})
		builder.addCase(fetchFolderList.fulfilled, (state, action) => {
			endLoading(state);
			endFolderLoading(state);
			state.folders = action.payload;
		})
		builder.addCase(fetchFolderList.rejected, (state, action) => {
			endLoading(state);
			endFolderLoading(state);
			state.error = action.payload;
		})

		builder.addCase(getFolderFiles.pending, (state) => {
			beginLoading(state);
			beginFolderLoading(state);
		})
		builder.addCase(getFolderFiles.fulfilled, (state, action) => {
			endLoading(state);
			endFolderLoading(state);
			// state.folderContent = action.payload;
			state.folderContent = {
				folders: action.payload.folders || [],
				files: action.payload.files || []
			};
		})
		builder.addCase(getFolderFiles.rejected, (state, action) => {
			endLoading(state);
			endFolderLoading(state);
			state.error = action.payload;
		})

		builder.addCase(uploadFile.pending, (state) => {
			beginLoading(state);
			beginFolderLoading(state);
		})
		builder.addCase(uploadFile.fulfilled, (state, action) => {
			endLoading(state);
			endFolderLoading(state);
			// Optionally, you can add the newly uploaded file to the folders
			state.folders.push(action.payload);
		})
		builder.addCase(uploadFile.rejected, (state, action) => {
			endLoading(state);
			endFolderLoading(state);
			state.error = action.payload;
		})

		// 1) ====== builders for checkFolderPermission ======

		builder.addCase(checkFolderPermission.pending, (state) => {
			beginLoading(state);
		});

		builder.addCase(checkFolderPermission.fulfilled, (state, action) => {
			endLoading(state);
			state.permission = action.payload;
		});

		builder.addCase(checkFolderPermission.rejected, (state, action) => {
			endLoading(state);
			state.error = action.payload.message;
		});
	},
});

export default documentFormSlice.reducer;
export const { clearDocumentForm, setSelectedFolder, setSliceCurrentFolderId } = documentFormSlice.actions;
